import { atom, useAtom } from "jotai";

export const dialogsAtom = atom([]);
export const nextDialogIdAtom = atom(0);

export function useDialogBetter() {
    const [dialogs, setDialogs] = useAtom(dialogsAtom);
    const [nextDialogId, setNextDialogId] = useAtom(nextDialogIdAtom);

    const closeDialog = () => {
        setDialogs((prev) => {
            return prev.filter((dialog) => dialog.id !== nextDialogId);
        });
    };

    const openDialog = ({ Component, componentProps: props, onCloseFn = () => {} }) => {
        setDialogs((dialogs) => [
            ...dialogs,
            {
                id: nextDialogId,
                Component,
                props,
                open: true,
                onClose: () => {
                    onCloseFn();
                    closeDialog();
                },
            },
        ]);
        setNextDialogId((id) => id + 1);
    };

    return { openDialog, closeDialog };
}
